import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from 'react-redux';

function PrivateRouter({ component: Component, ...rest }) {
  return (
    <Route {...rest}
      render={props =>
        rest.services.bookingDetails ? (<Component {...props} />) :
          (<Redirect to={{ pathname: "/", state: { from: props.location } }} />)
      }
    />
  );
}

const mapStateToProps = (state) => {
  return {
    services: state.services,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {}
  };
};


export const PrivateRoute = connect(mapStateToProps, mapDispatchToProps)(PrivateRouter);